module.exports = __webpack_public_path__ + "img/Come, Come To The Sunset Tree.03536174.jpg";